import router from '../../router'
import { AUTH_COOKIE } from '../modules/user'
import { AUTH_API_COOKIE } from '../modules/user'
import jscookie from 'js-cookie'
import hexRgb from'hex-rgb'

const apiEsriToken					=	jscookie.get(AUTH_API_COOKIE)



const state = {
  spaceSummary: null,
  roomUseSummary: null,
  roomCategorySummary: null,
  roomClassificationSummary: null,
  collegeSummary: null,
  buildings: [],
  selectedBuilding: null,
  buildingRooms: [],
  buildingRoomsFull: [],
  buildingFiles: [],  
  selectedRoom: null,			// This is a non-verbose (fast) room Object
  fullRoom: null,				// This is a verbose room Object
  suspendRouting: false,
  photos: [],
}

const mutations = {

	setPhotos (state, payload) {
		state.photos = payload
	},
	addRoomToBuildingRooms (state, payload) {
		state.buildingRooms.push(payload)
	},
	setRoomUseSummary (state, payload) {
		state.roomUseSummary = payload
	},
	setRoomClassificationSummary (state, payload) {
		state.roomClassificationSummary = payload
	},
	setRoomCategorySummary (state, payload) {
		state.roomCategorySummary = payload
	},
	setCollegeSummary (state, payload) {
		state.collegeSummary = payload
	},
	setSpaceSummary (state, payload) {
		state.spaceSummary = payload
	},
	setBuildings (state, payload) {
		//console.log(payload.find((bldg) => bldg.bldgAlpha == "101") ? "Using Secured Data" : "Not Using Secured Data")
		state.buildings = payload
	},
	setBuildingRooms (state, payload) {
		state.buildingRooms = payload
	},
	setBuildingRoomsFull (state, payload) {
		state.buildingRoomsFull = payload
	},
	setBuildingFiles (state, payload) {
		state.buildingFiles = payload
	},
	setSuspendRouting(state, payload) {
		state.suspendRouting = payload
	},
	setRoomNoRoute (state, payload) {
		//console.log("Mutation: setRoomNoRoute: ", payload)
		if (payload) {
			state.selectedRoom = payload
		} else {
			state.selectedRoom = null
		}
	},
	setFullRoomNoRoute (state, payload) {
		//console.log("Mutation: setFullRoomNoRoute: ", payload)
		if (payload) {
			state.fullRoom = payload
		} else {
			state.fullRoom = null
		}
	},
	setSelectedRoom (state, payload) {
		//console.log("Mutation: setSelectedRoom: ", payload)
		if (payload) {
	
			// Sometimes a room can be selected from another building, keep in sync
			if (!state.selectedBuilding || payload.bldgAlpha != state.selectedBuilding.bldgAlpha) {
				this.dispatch('selectBuilding', payload.bldgAlpha )
			}

			state.selectedRoom = payload
			router.push({ name: 'highlightRoom', params: { bldg: payload.bldgAlpha, room:payload.number }})

		} else {
			state.selectedRoom = null
		}
	},
	setFullRoom (state, payload) {
		state.fullRoom = payload		
	},

	setBuilding (state, payload){
		console.log("Mutation: Set Building")
		state.selectedBuilding = payload
	},

	setSelectedBuilding (state, payload, rootState) {	// Payload is building object
		state.selectedBuilding = payload
		//state.selectedRoom = null
		this.commit('setclVisible', false)
		
		// Im feeling like this should all be someplace else.
		//console.log(router.history.current.name)
		if (router.history.current.name == 'roomtableBldg') {
			if (payload) {
				router.push({ name: 'roomtableBldg', params: { bldg: payload.bldgAlpha }}) 
			} else {
				router.push({ name: 'roomtableBldg'})
			}
		}
		if (router.history.current.name != 'roomtableBldg') {
		 	if (payload) {
		 		router.push({ name: 'highlightBuilding', params: { bldg: payload.bldgAlpha }})
		 	} else {
				router.push({ name: 'home'})
			} 
		}

	},
// Moved to colorRooms.js
/*	setcolorizeProperty(state, payload) {
		state.colorizeProperty = payload
	},
	setColorizeFeatureAttribute(state, payload) {
		state.colorizeFeatureAttribute = payload
	},
	setColorizeArray(state, payload) {
		console.log("Mutation: setColorizeArray: ", payload)
		state.colorizeArray = payload
	},*/
/*	resetColorize(commit) {
		//console.log("ResetColorize")
		state.colorizeArray = []
		state.colorizeFeatureAttribute = null
		state.colorizeProperty = null
	},*/
}

const getters = {
  	getMapSelectors : function (state, getters, rootState) {
  		let bldg = (state.selectedBuilding) ? state.selectedBuilding.bldgAlpha : null
  		let floor = (rootState.ui.currentFloor) ? rootState.ui.currentFloor : null
  		let room = (state.selectedRoom) ? state.selectedRoom.roomKey : null
		return `${bldg}|${floor}|${room}`
	},

  	getRoom : (state) => (roomKey) => { 
   	 	//console.log("Getter: getRoom: " + roomKey)
   	 	//console.log(state.buildingRooms.find(room => room.roomKey == roomKey))
   	 	return state.buildingRooms.find(room => room.roomKey == roomKey)
  	},

	getBuilding : (state, rootState) => (bldgnumber) => {
		console.log("GetBuilding", bldgnumber)
		let returnBuilding = state.buildings.find(bldg => bldg.bldgAlpha == bldgnumber)

		// Only return 'Active' status buildings
		if (returnBuilding && returnBuilding.status) {
			if (returnBuilding.status == 'A' || rootState.user.isSuperUser) { return returnBuilding }
	  }
		// else
		console.log("getBuilding: Deleted Building")
		return null		 
	},

	getDatabase : (state, getters, rootState) => () => {
		return rootState.ui.useDevDatabase ? 'spacedev' : 'PRODUCTION'
	},

/*	getFullRoom : (state) => (bldg, room) => {
		console.log("getFullRoom")
		if(state.selectedRoom) {
			console.log("getFullRoom")
			return this.dispatch('fetchFullRoom', bldg, room)
		}
	},*/




// retired in favor of colorRooms.js module and moving away from color by day-old GIS Attributes

/*    colorizeArray: function (state, getters, rootState) {
		if (state.colorizeProperty) {
			//console.log("Building Colorize Array")

			// Get unique labels/items that will build legend and summarize area into label/item groups.
			const legendItems = getters.legendItems

			// Get rooms for current building, current floor
			const floorRooms = state.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)

			const colorizeArray = []   // uniqueCategory, Area, Color			

			// For each legend item, find matching rooms in floorRooms, summarize area, push into colorizeArray
			legendItems.forEach((legendItem) => {

				let area = 0

				// All rooms for one room attribute [type, use, etc]
				const rooms = floorRooms.filter((room) => room[state.colorizeProperty] === legendItem)			

				// Summarize Area for each legend item
				rooms.forEach((room) => {	area += room.area })
				
				// Create element in colorize Array
				const element = { 'categoryVal' : legendItem, 'area' : area }
				colorizeArray.push(element)
			})

			// Sort Array on Area
			colorizeArray.sort(function(a,b) {return b.area - a.area});

			// Choose colors automatically		

			let colorIntervals = 0.0
			const interpolate = d3.interpolateHclLong("rgb(121, 0, 130)", "rgb(130, 88, 0)"); 
			let spreadfactor = 1/colorizeArray.length			

			colorizeArray.forEach((element) => {
				
				let colorCode = interpolate(colorIntervals);
				colorIntervals += spreadfactor;

				// These exceptions are colored grey
				if (element.categoryVal == "Unassignable Space" || 
					element.categoryVal == "Circulation Area" || 
					element.categoryVal == "Circulation" || 
					element.categoryVal == "Business Affairs General" || 
					element.categoryVal == "Not Classified" || 
					element.categoryVal == "None") {                        
                    colorCode = "rgb(75 ,75 ,75)";
                }

                // Shared is always this color
                if (element.categoryVal == "Shared") { colorCode = "rgb(255, 30, 30)" }

                // Add color to this colorizeArray element
                element.color = colorCode

                // Lookup any Custom Colors and override/replace
            	let fRow = rootState.user.colors.find((item) => { return item.legendLabel == element.categoryVal })
            	if (fRow) {
            		//console.log("Found Custom Color")
		            element.color = `rgb(${hexRgb(fRow.color).red}, ${hexRgb(fRow.color).green}, ${hexRgb(fRow.color).blue})`
		            //if (value == "#FFFFFF") { this.currentColorPicker.color = 'rgb(255,255,255)' }
            	}

			})

			//console.log("Colorize Array: ")
			//console.log(colorizeArray)
			return colorizeArray
		} else { 
			return null 
		}
	}, */

	// Produces list of attribute values for given room using colorizeProperty as the attribute name
/*	legendItems: (state, getters, rootState) => {		// rootState is 3rd argument
		const floorRooms = state.buildingRooms.filter((room) => room.floor === rootState.ui.currentFloor)
		let list = []
		floorRooms.forEach((room) => {
		    if (list.indexOf(room[state.colorizeProperty]) === -1) {
			    list.push(room[state.colorizeProperty])
			}
		})
		return list
	},*/
}



const actions = {

	fetchSpaceSummary ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/spacesummary', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setSpaceSummary', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},

	fetchRoomUseSummary ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/spacesummary/roomuse', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setRoomUseSummary', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},

	fetchRoomCategorySummary ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/spacesummary/roomcategory', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setRoomCategorySummary', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},

	fetchRoomClassificationSummary ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/spacesummary/roomclassification', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setRoomClassificationSummary', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},

	fetchCollegeSummary ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/spacesummary/colleges', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setCollegeSummary', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},
	// List of building table and supporting properties
	fetchBuildings ({commit, getters}) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: fetchBuildings ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/buildings', {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json'
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setBuildings', data) // Commit mutation above
		        resolve(data)
		      })
		})
	},

	// One Building
	fetchBuilding ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: fetchBuilding ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/building/' + payload, {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	// High level function for selecting a new building in IF
	selectBuilding ({commit, dispatch, getters, state, rootState}, payload) {	// payload = a building Number		
		//console.log("Action: selectBuilding " + payload)
		//console.trace("selecteBuilding trace")

		if (state.selectedBuilding && state.selectedBuilding.bldgAlpha == payload) {
			//console.log("Building already selected, do nothing")
			return
		}
		
		if (!payload) {
			commit('setSelectedBuilding', null)
			commit('setBuildingFiles', []	)
			commit('setBuildingRoomsFull', [])
			commit('setSelectedRoom', null)
			commit('setFullRoom', null)

		} else if (state.selectedBuilding != this.getters.getBuilding(payload)) {

			return new Promise((resolve, reject) => {
				commit('setBuildingRooms', [])
				commit('setBuildingFiles', []	)
				dispatch('addFloorPlanDetail', payload)
				commit('setSelectedBuilding', this.getters.getBuilding(payload))

				// if the current floor is not represented in the newly selected building
				if (state.selectedBuilding.floors.indexOf(rootState.ui.currentFloor) === -1) {  // comment this out to ALWAYS go floor one, or first valid.
					// Select floor 1 if it exists, else select first valid floor
					//console.log(state.selectedBuilding)
					commit('setCurrentFloor', (state.selectedBuilding.floors.indexOf("1") === -1) ? state.selectedBuilding.floors[0] : "1")
					if (!rootState.ui.currentFloor) { 
						console.log("%c ERROR: Building has no floors.", 'background: red; color: white; display: block;')
					}
				}
								
				dispatch('fetchBuildingFiles', payload)
				
				// Prefetch some useful data
				dispatch('fetchBuildingRooms', payload).then(response => {
					resolve(response)
				}, error => {
					reject(error)
				}) 
			})
		}
	},

	// List of building drawings with floors
	fetchBuildingFiles ({commit, getters}, payload) {
		//	console.log("Action: fetchBuildingFiles", payload)
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		return new Promise((resolve, reject) => {
	  		fetch('https://api.ba.arizona.edu/if/floorplans/' + payload || state.selectedBuilding.bldgAlpha, {      
		      headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		      	commit('setBuildingFiles', data)
		        resolve(data)
		      })
		})
	},

	// Room with child tables
	fetchFullRoom ({rootState, commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		commit('setFullRoom', null)
		//console.log("Using Database: ", getters.getDatabase())
		if (payload) {
			//console.log("Action: fetchFullRoom " + payload.bldgAlpha + ":" + payload.number)
/*			console.groupCollapsed("Trace")
			console.trace("trace")
			console.groupEnd()*/
			return new Promise((resolve, reject) => {
				fetch('https://api.ba.arizona.edu/if/room/' + payload.bldgAlpha + '/' + payload.number, {      
			      headers: 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            		'impersonate' : getters.impersonateID,
		      			}
		  			})
			      .then(response => response.json())
			      .then(data => {

			        if (!payload.noSet) {
			        	commit('setFullRoom', data) 
			        	commit('setSelectedRoom', data)
			    	}
			        resolve(data)
			      })
			  })
		} 
	},

	// Find room by associated AutoCAD key.  Requires prior "association" to have been made.
	fetchFullRoomByJoinKey ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		if (payload) {
			console.log("Action: fetchFullRoomByJoinKey " + payload)
			return new Promise((resolve, reject) => {
				fetch('https://api.ba.arizona.edu/if/room/joinKey',
				 {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
		            						'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
			      .then(response => response.json())
			      .then(data => {
			        resolve(data)
			      })
			  })
		} 
	},

	// All rooms for one department.  Shallow return
	fetchDepartmentRooms ({rootState, commit, getters}, deptID) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchDepartmentRooms " + deptID)
			fetch('https://api.ba.arizona.edu/if/rooms/dept/' + deptID, {      
		      headers: rootState.user.isSuperUser ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            		'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				          'content-type': 'application/json',
		            	'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	//console.log(data)
		      	if (data.Message) {
		      		console.log("Rooms failed to load")
		      		resolve(data)
		      	} else {			        
			        console.log("Rooms Fetched: " + data.length) 
			        resolve(data)
		    	}
		      })
	  	})
	},

	// All rooms for one department.  Includes PCT
	fetchDepartmentRoomsFull ({rootState, commit, getters}, deptID) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchDepartmentRooms " + deptID)
			fetch('https://api.ba.arizona.edu/if/rooms-full/dept/' + deptID, {      
		      headers: rootState.user.isSuperUser ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            	'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				            'content-type': 'application/json',
		            	'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	//console.log(data)
		      	if (data.Message) {
		      		console.log("Rooms failed to load")
		      		resolve(data)
		      	} else {			        
			        console.log("Rooms Fetched: " + data.length) 
			        resolve(data)
		    	}
		      })
	  	})
	},

	// All rooms for one college.  Shallow return
	fetchCollegeRooms ({rootState, commit, getters}, collegeID) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchCollegeRooms " + collegeID)
			fetch('https://api.ba.arizona.edu/if/rooms/college/' + collegeID, {      
		      headers: rootState.user.isSuperUser ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            		'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				          'content-type': 'application/json',
		            	'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	//console.log(data)
		      	if (data.Message) {
		      		console.log("Rooms failed to load")
		      		resolve(data)
		      	} else {			        
			        console.log("Rooms Fetched: " + data.length) 
			        resolve(data)
		    	}
		      })
	  	})
	},

	// All rooms for one college.  Return includes PCT
	fetchCollegeRoomsFull ({rootState, commit, getters}, collegeID) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchCollegeRooms " + collegeID)
			fetch('https://api.ba.arizona.edu/if/rooms-full/college/' + collegeID, {      
		      headers: rootState.user.isSuperUser ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	//console.log(data)
		      	if (data.Message) {
		      		console.log("Rooms failed to load")
		      		resolve(data)
		      	} else {			        
			        console.log("Rooms Fetched: " + data.length) 
			        resolve(data)
		    	}
		      })
	  	})
	},
	
	// All rooms for one building.  Shallow return
	fetchBuildingRooms ({rootState, commit, getters}, bldgAlpha) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)		
		return new Promise((resolve, reject) => {
			//console.log("Action: fetchBuildingRooms " + bldgAlpha)
			fetch('https://api.ba.arizona.edu/if/rooms/' + bldgAlpha, {      
		      headers: rootState.user.viewRestricted ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	//console.log(data)
		      	if (data.Message) {
		      		console.log("Rooms failed to load")
		      		resolve(data)
		      	} else {
			        commit('setBuildingRooms', data)
			        //console.log(data)
			        resolve(data)
		    	}
		      })
	  	})
	},

	// All rooms for one building floor.  Shallow return
	fetchSelectedBuildingRooms ({rootState, commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			console.log("Action: fetchSelectedBuildingRooms")
			fetch('https://api.ba.arizona.edu/if/rooms/' + state.selectedBuilding.bldgAlpha, // + '/' + rootState.ui.currentFloor
					{   

		      			headers: rootState.user.isSuperUser ? 
		      			{
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			} :
		      			{
		      				'database' : getters.getDatabase(),
				            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      			}
		  	})
		      .then(response => response.json())
		      .then(data => {
		        commit('setBuildingRooms', data)
		        //console.log("Rooms Fetched: " + data.length) 
		        resolve(data)
		      })
	  	})
	},

	// All rooms for one building.  Deep Return (child tables)
	fetchBuildingRoomsFull ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		commit('setBuildingRoomsFull', [])
		
		//console.log(payload)
		return new Promise((resolve, reject) => {
			//console.log("Action: fetchBuildingRoomsFull ", payload)
			let fetchURL = (payload.floor) ? 'https://api.ba.arizona.edu/if/rooms-full/' + payload.bldgAlpha + '/' + payload.floor
								   : 'https://api.ba.arizona.edu/if/rooms-full/' + payload 
			fetch(fetchURL, {      
		      headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setBuildingRoomsFull', data) 
		        resolve(data)
		      })
		    })
	},

	// Data from floor table, one floor and supporting properties
	fetchFloor ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchFloor ")
			fetch('https://api.ba.arizona.edu/if/floor/' + payload.bldgAlpha + "/" + payload.floor, {      
		      headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
	  	})
	},

	
	fetchOccupantHistoryData ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			console.log("Action: fetchOccupantHistoryData", payload)
			fetch('https://api.ba.arizona.edu/if/occupant/history/' + payload.key, {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
		    .catch(e => {
		        console.log(e);
		        return 
		    })
	  	})
	},

	fetchPIHistoryData ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			console.log("Action: fetchPIHistoryData", payload)
			fetch('https://api.ba.arizona.edu/if/pi/history/' + payload.key, {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
		    .catch(e => {
		        console.log(e);
		        return 
		    })
	  	})
	},

	// All 40,000+ rooms.  Shallow Return
	fetchAllRooms ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			console.log("Action: fetchAllRooms ")
			fetch('https://api.ba.arizona.edu/if/rooms/all', {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
	  	})
	},

	// CTS Rooms
	fetchCtsRooms ({commit, getters}, payload) {
		//const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchCTSRooms ")
			fetch('https://api.ba.arizona.edu/if/rooms/cts', {      
		      	headers: {
		      		  //'database' : getters.getDatabase(),
		            //'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
	  	})
	},


	// All Room Photos
	fetchAllRoomPhotos ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchFloor ")
			fetch('https://api.ba.arizona.edu/if/photos/rooms', {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
	  	})
	},

	// All Room Photos that need approval
	fetchUnapprovedPhotos ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchFloor ")
			fetch('https://api.ba.arizona.edu/if/photos/rooms/unapproved', {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
	  	})
	},

	// Photos for one room
	fetchRoomPhotos ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

		return new Promise((resolve, reject) => {
			//console.log("Action: fetchFloor ")
			fetch('https://api.ba.arizona.edu/if/photos/room', {      
		      	headers: {
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      	},
		      	method: "POST",
                body: JSON.stringify({'roomKey': payload})
		  	})
		    .then(response => response.json())
		    .then(data => {
		        resolve(data)
		    })
	  	})
	},
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/space.js